import classNames from 'classnames';
import { UnderlyingBadge, UnderlyingBadgesList } from 'components/common-form/sidePanel/info/UnderlyingBadge';
import { SpTooltip } from 'components/shared/Tooltip/Tooltip';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import type { Underlying } from 'models/underlying';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface UnderlyingsProps {
  id: string;
  firstItems: Underlying[];
  moreItems: Underlying[];
  className?: string;
}

export const UnderlyingsComponent: FC<UnderlyingsProps> = ({ firstItems, id, className, moreItems }) => {
  const moreItemsCount = moreItems.length;
  const { formatMessage } = useIntl();

  const theme = useSgBsTheme();

  return (
    <div className={classNames('d-flex flex-nowrap px-3 pb-1', className)} title={formatMessage({ id: 'Underlyings' })}>
      <UnderlyingBadgesList underlyings={firstItems} />

      {moreItemsCount > 0 && (
        <SpTooltip
          position="bottom"
          color="secondary"
          contents={
            <div className="p-1">
              <div className={`fw-bold pb-2 fs-6`}>
                {formatMessage({ id: 'dashboard.moreUnderlyings' }, { count: moreItemsCount })}
              </div>
              <div className="d-flex flex-wrap">
                {moreItems.map(underlying => (
                  <UnderlyingBadge key={underlying.id} underlying={underlying} className="py-1 me-1" />
                ))}
              </div>
            </div>
          }
        >
          <button id={`btn-${id}`} className={classNames('btn btn-sm', `btn-outline-${theme}`, 'text-primary')}>
            {`+${moreItemsCount}`}
          </button>
        </SpTooltip>
      )}
    </div>
  );
};

UnderlyingsComponent.displayName = 'UnderlyingsComponent';
